export default __webpack_public_path__ + "277e25f5234e0b17fadfcc3cab8633c5.png";